import {
    ICadastroDeDirecionamento,
    ICadastroDeDirecionamentoResponse,
    IClasseControleFinanceiro,
    IDirecionamentoPayload,
} from "../../../Interfaces/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamentoInterface";
import { ICategoriaAtendimento } from "../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function CadastroDeDirecionamentoService(
    requestBody: ICadastroDeDirecionamento
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/custos/cadastrodedirecionamentos`,
            requestBody
        )
    );
}

export async function getCadastroDeDirecionamentoService(ID_CUSTO: number) {
    return Service(
        Axios.get<ICadastroDeDirecionamento>(
            `/assistenciatecnica/custos/getcadastrodirecionamento?ID_CUSTO=${ID_CUSTO}`
        )
    );
}

export async function ListagemCadastroDeDirecionamentoService(
    requestBody: IDirecionamentoPayload
) {
    return Service(
        Axios.post<ICadastroDeDirecionamentoResponse>(
            `/assistenciatecnica/custos/listagemdecadastrodirecionamento`,
            requestBody
        )
    );
}

export async function AtualizacaoCadastroDeDirecionamentoService(
    requestBody: Array<ICadastroDeDirecionamento>
) {
    return Service(
        Axios.patch(
            `/assistenciatecnica/custos/atualizacaodecadastrodirecionamento`,
            requestBody
        )
    );
}

export async function DeleteCadastroDeDirecionamentoService(ID: number) {
    return Service(
        Axios.delete(
            `/assistenciatecnica/custos/remocaodecadastrodirecionamento?ID=${ID}`
        )
    );
}

export async function ListarClassesControlesDirecionamentoService() {
    return Service(
        Axios.get<Array<IClasseControleFinanceiro>>(
            `/assistenciatecnica/custos/listarclassescontrolesdirecionamento`
        )
    );
}

export async function ListarCategoriasAtendimentosPaiService() {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/assistenciatecnica/categoriaatendimento/listacategoriasatendimentospai`
        )
    );
}

export async function ListarCategoriasAtendimentosFilhoService(
    idCategoriaPai: number
) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/assistenciatecnica/categoriaatendimento/listacategoriasatendimentosfilhas?idCategoriaAtendimentoPai=${idCategoriaPai}`
        )
    );
}
